import http, { ResponseData } from './httpService'
import {
  CreateOrderRequest,
  CreateOrderResponse,
  OrderInterface,
  TemplateMerchantInterface,
  QueryPriceInterface, QueryKeFuUrl,
  GetOpenidface, BlinkInterface, ActivewxidInterface
} from '@src/typings/orderTypes'
import { PageInterface } from '@src/typings/types'

export const getOrders = async (): Promise<OrderInterface[]> => {
  const { data } = await http.post<ResponseData<PageInterface<OrderInterface>>>('/fe/user/center/order/user/list', {
    current: 1,
    pageSize: 100,
  })
  return data.data.records
}

export const facade = async (linkId: String): Promise<TemplateMerchantInterface> => {
  const { data } = await http.get<ResponseData<TemplateMerchantInterface>>('/fe/user/center/order/facade/' + linkId)
  return data.data
}

export const blink = async (linkId: String): Promise<BlinkInterface> => {
  const { data } = await http.get<ResponseData<BlinkInterface>>('/fe/user/center/order/blink/' + linkId)
  return data.data
}

export const create = async (param: CreateOrderRequest): Promise<CreateOrderResponse> => {
  const { data } = await http.post<ResponseData<CreateOrderResponse>>('/fe/user/center/order/create', param)
  return data.data
}

export const payment = async (orderId: String, code: String): Promise<string> => {
  const { data } = await http.get<ResponseData<string>>('/fe/user/center/payment/' + orderId + '?code=' + code)
  return data.data
}

export const report = async (orderId: String): Promise<ResponseData<Map<String, any>>> => {
  const { data } = await http.get<ResponseData<Map<String, any>>>('/fe/user/center/report/' + orderId)
  return data
}
// 获取是否存在优惠卷
export const coupon = async (linkId: String): Promise<ResponseData<Boolean>> => {
  const { data } = await http.post<ResponseData<Boolean>>('fe/user/center/order/coupon/' + linkId)
  return data
}

// 价格查询
export const queryPrice = async (param: QueryPriceInterface): Promise<ResponseData<Number>> => {
  const { data } = await http.post<ResponseData<Number>>('/fe/user/center/order/queryPrice', param)
  return data
}

// 获取appid
export const activeWxid = async (param: ActivewxidInterface): Promise<ResponseData<String>> => {
  const { data } = await http.post<ResponseData<String>>('fe/user/center/payment/activewxid2',param)
  return data
}

// 获取openid
export const getOpenid = async (param: GetOpenidface): Promise<ResponseData<String>> => {
  const { data } = await http.post<ResponseData<String>>('fe/user/center/order/openid', param)
  return data
}



export const queryKeFuUrl = async (param: QueryKeFuUrl): Promise<ResponseData<String>> => {
  try {
    const { data } = await http.post<ResponseData<String>>('/fe/user/center/merchant/queryKeFuUrl', param)
    return data
  } catch (e) { }
  return {
    errorCode: 200,
    data: '',
    errorMessage: '',
    success: true
  };
}

